import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { BookingInfoProperties, BookingPassengerInfoProperties, SectorInformationProperties } from '../Models/BookingPassengerTicketIssuanceProperties';
import { FlightSearchDestinationProperties } from '../Models/FlightSearchProperties';
import { TicketIssuanceService } from '../Services/ticketIssuance.service';
import {
  faPlaneDeparture,
  faPlaneArrival
} from '@fortawesome/free-solid-svg-icons';
import { bookingInfoForONEG, ExchangeEligibility } from '../Models/TravelPortNewProperties';
import { TravelPortService } from '../Services/travel-port.service';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
@Component({
  selector: 'app-travel-port-modification',
  templateUrl: './travel-port-modification.component.html',
  styleUrls: ['./travel-port-modification.component.css']
})
/** TravelPortModification component*/
export class TravelPortModificationComponent {
  faPlaneDeparture = faPlaneDeparture;
  removePassengerPopup: boolean;
  optionchangeforsomepass: boolean = true;
  passengerForm: FormGroup;
  constructor(private fb: FormBuilder, private messageservice: MessageService, private servicetravel: TravelPortService, private confirmationService: ConfirmationService, private router: Router) {
  }
  optionlist: any[] | undefined;
  selectoption: string | undefined;
  changeBooking: boolean = false;
  passengerDetails: boolean = false;
  changeBookingNotAvail: boolean = false;
  removepassengers: boolean = false;
  sectorInformation: [] = [];
  bookingInfo = new BookingInfoProperties();
  exchangeEligibility = new ExchangeEligibility();
  bookingModifyProp = new bookingInfoForONEG();
  ngOnInit() {
    let actionperformed = localStorage.getItem("actiontype");
    this.bookingInfo = JSON.parse(localStorage.getItem("bookingInfotravelport"));
    if (actionperformed == "changeBooking") {

      this.NewLoaderEmirates = true;
      this.servicetravel.ModifyReservationEligibility(this.bookingInfo).subscribe((data) => {

        this.exchangeEligibility = data;
        if (this.exchangeEligibility.exchangeable == "all") {
          this.selectoption = "all";
          this.onOptionChange();
          this.optionchangeforsomepass = false;
          this.changeBooking = true;
        }

        else if (this.exchangeEligibility.exchangeable == "none") {
          this.changeBooking = false;
          this.changeBookingNotAvail = true;
        }
        else {
          this.changeBooking = true;
        }
        this.NewLoaderEmirates = false;
      });





    }
    else if (actionperformed == "passengerDetails") {
      this.servicetravel.GetUpdateableItemsOfPassenger(this.bookingInfo).subscribe((data) => {
        this.bookingModifyProp = data;
        this.passengerDetails = true;
      });
    }
    this.optionlist = [
      { name: 'All Sector', code: 'all' },
      { name: 'Some Sector', code: 'some' }
    ];
  }
  activeColor: string = '';

  changeBackground(color: string) {
    this.activeColor = color;
  }
  somesector: boolean = false;
  aLLsector: boolean = false;

  selectedPassengers: { [key: string]: boolean } = {};
  buttonsshow: boolean = false;
  onOptionChange() {
    if (this.selectoption == "some") {

      for (let p = 0; p < this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo.length; p++) {
        this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[p].modifyDeparture = false;
      }
      this.somesector = true;
      this.buttonsshow = true;
      this.aLLsector = false;
    }
    else {
      for (let p = 0; p < this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo.length; p++) {
        this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[p].modifyDeparture = true;
      }
      this.buttonsshow = true;
      this.somesector = true;
      this.aLLsector = true;
    }
  }
  NewLoaderEmirates: boolean = false;
  modifyClick() {
    if (this.selectoption == "some") {
      let countofsome = 0;
      for (let p = 0; p < this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo.length; p++) {
        if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[p].modifyDeparture) {
          countofsome++;
        }
      }
      if (countofsome == this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo.length) {
        this.messageservice.add({ severity: 'error', summary: 'Rejected', detail: 'Select Some Sector Only', life: 3000 });
        return;
      }
    }
    this.confirmationService.confirm({
      header: 'Confirmation',
      message: 'Please confirm to proceed moving forward.',
      acceptIcon: 'pi pi-check mr-2',
      rejectIcon: 'pi pi-times mr-2',
      rejectButtonStyleClass: 'p-button-sm',
      acceptButtonStyleClass: 'p-button-outlined p-button-sm',
      accept: () => {
        localStorage.setItem("flightmodifyBookingInfo", JSON.stringify(this.bookingInfo));
        localStorage.setItem("flightmodifysearch", JSON.stringify(this.bookingInfo.galileoBookingProp.flightProp));
        this.router.navigateByUrl('/flightResultModify');
      },
      reject: () => {
        this.messageservice.add({ severity: 'error', summary: 'Rejected', detail: 'Not Modify', life: 3000 });
      }
    });


  }
  modifyUpdateDetailsClick() {

    let countofsome = 0;
    for (let p = 0; p < this.bookingModifyProp.bookingPassengerInfoProperties.length; p++) {
      if (this.bookingModifyProp.bookingPassengerInfoProperties[p].selectToModify) {
        countofsome++;
      }
    }
    if (countofsome==0) {
      this.messageservice.add({ severity: 'error', summary: 'Rejected', detail: 'Select Some Passenger To Modify', life: 3000 });
      return;
    }
  
    this.confirmationService.confirm({
      header: 'Confirmation',
      message: 'Please confirm to proceed moving forward.',
      acceptIcon: 'pi pi-check mr-2',
      rejectIcon: 'pi pi-times mr-2',
      rejectButtonStyleClass: 'p-button-sm',
      acceptButtonStyleClass: 'p-button-outlined p-button-sm',
      accept: () => {
        this.servicetravel.UpdateThePassengerDetails(this.bookingModifyProp).subscribe((data) => {
          this.NewLoaderEmirates = true;
          if (data.isSaved) {
            localStorage.setItem("bookingID", this.bookingInfo.bookingID.toString())
            this.router.navigateByUrl('/ticket-issuance');
          }
          else {
            this.messageservice.add({ severity: 'error', summary: 'Rejected', detail: data.errorInfo, life: 3000 });

          }
        });
      
      },
      reject: () => {
        this.messageservice.add({ severity: 'error', summary: 'Rejected', detail: 'Not Modify', life: 3000 });
      }
    });


  }

}
